/**
 * @file Renders the schedule's project name label.
 */
import { Bold } from "@components/Text";

import type { ScheduleFormValues } from "../types";

const LABEL_SCHEDULE = "Project";

type Props = {
  initialValues: ScheduleFormValues;
};

/**
 * Renders the project name the distribution schedule belongs to.
 */
const ScheduleName = ({ initialValues }: Props) => (
  <span>
    {`${LABEL_SCHEDULE}:`} <Bold>{initialValues.name}</Bold>
  </span>
);

export default ScheduleName;
